import Vue from 'vue'
import Vuex from 'vuex'
import { isStrEmpty, getConfig, setConfig, isObjEmpty } from '@/utils/utils'
import { getUserInfo } from '@/services/axios'
import ConfigService from "@/services/account.service";

const GAMES_SLUG: string = process.env.VUE_APP_ENABLE_GAMES_SLUG || '';

Vue.use(Vuex)
interface RootState {
    userInfo: any;
    configAccount:any;
    isScreenMobile: boolean;
    dataBetslip: any[];
    dataCheckout: any[];
    versionApp: string;
}
export default new Vuex.Store<RootState>({
    state: {
        userInfo: !isStrEmpty(getUserInfo()) ? JSON.parse(getUserInfo()) : null,
        configAccount: !isStrEmpty(getConfig()) ? JSON.parse(getConfig()) : null,
        isScreenMobile: false,
        dataBetslip: [],
        dataCheckout: [],
        versionApp: '1.1.1',
    },
    getters: {},
    mutations: {
        SET_USER_INFO(state, data) {
            state.userInfo = data
        },

        REMOVE_USER_INFO(state) {
            state.userInfo = null
            localStorage.removeItem('user_info')
        },
        SET_CONFIG(state, data) {
            const dataClone = data;
            const slugGames = GAMES_SLUG.split(",");
            const dataListGames = localStorage.getItem('listGames') ? JSON.parse(localStorage.getItem('listGames') || '') : [];
            if ( slugGames.length > 0) {
                slugGames.forEach(item => {
                    if (!(dataListGames.find((e) => e.game && e.game.slug === item)) && !isObjEmpty(dataClone?.gameConfigs?.[item])) {
                        dataClone.gameConfigs[item].enabled = false;
                    }
                })
            }
            state.configAccount = dataClone;
        },
        ADD_TO_BETSLIP(state, data) {
            state.dataBetslip = [...state.dataBetslip, ...data]
            localStorage.setItem('betslip', JSON.stringify(state.dataBetslip))
        },
        CLEAR_ALL_BETSLIP(state) {
            state.dataBetslip = []
            localStorage.setItem('betslip', JSON.stringify(state.dataBetslip))
        },
        CLEAR_ITEM_BETSLIP(state, index) {
            state.dataBetslip.splice(parseInt(index), 1)
            localStorage.setItem('betslip', JSON.stringify(state.dataBetslip))
        },
        ADD_TO_CHECKOUT(state, data) {
            state.dataCheckout = state.dataCheckout.concat(data)
            localStorage.setItem('checkout', JSON.stringify(state.dataCheckout))
        },
        CLEAR_ALL_CHECKOUT(state) {
            state.dataCheckout = []
            localStorage.setItem('checkout', JSON.stringify(state.dataCheckout))
        },
        CLEAR_ITEM_CHECKOUT(state, param) {
            if (param.typeGame === 1) {
                state.dataCheckout.splice(param.index, 1);
            } else if (param.typeGame === 2) {
                const data = state.dataCheckout[param.index].data;
                const newData = data.filter((item, idx) => idx !== param.idItem);
                state.dataCheckout[param.index].data = newData;
                if (newData.length === 1) {
                    const { betAmount, ...rest } = state.dataCheckout[param.index];
                    state.dataCheckout[param.index] = {
                        ...rest,
                        ...newData[0],
                        betAmount,
                        typeGame: 1
                    };
                }
            }
            localStorage.setItem('checkout', JSON.stringify(state.dataCheckout));
        },
    },
    actions: {
        handleUserInfo({ commit, state }, data) {
            commit('SET_USER_INFO', data)
        },
        removeUserInfo({ commit }) {
            commit('REMOVE_USER_INFO')
        },
        handleConfig({ commit, state }, data) {
            commit('SET_CONFIG', data)
        },
        addToBetslip({ commit }, data) {
            commit('ADD_TO_BETSLIP', data);
        },
        clearAllBetslip({ commit }) {
            commit('CLEAR_ALL_BETSLIP');
        },
        clearItemBetslip({ commit }, index) {
            commit('CLEAR_ITEM_BETSLIP', index);
        },
        addToCheckout({ commit }, data) {
            commit('ADD_TO_CHECKOUT', data)
        },
        clearAllCheckout({ commit }) {
            commit('CLEAR_ALL_CHECKOUT');
        },
        clearItemCheckout({ commit }, param) {
            commit('CLEAR_ITEM_CHECKOUT', param);
        },
        async fetchDataConfig({ commit }){
            try {
                const res = await ConfigService.getConfig();
                if (res.status === "success") {
                    setConfig(res.data);
                    commit('SET_CONFIG', res.data);
                    return res;
                }else{
                  console.log(res);
                  throw new Error(res)
                }
              }catch(error){
                console.log(error);
                throw error;
              }
        },
    },
})
